import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Table } from '../services/api.service';

@Component({
  selector: 'app-table-select-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-gray-900 rounded-xl p-6 mx-4 w-full max-w-md max-h-[70vh] overflow-hidden">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold text-white">Tisch auswählen</h3>
          <button (click)="closed.emit()" class="text-gray-400 hover:text-white">
            <span class="material-symbols-outlined text-2xl">close</span>
          </button>
        </div>
        <div class="overflow-y-auto max-h-80">
          @if (tables().length === 0) {
            <div class="text-center py-8 text-gray-400">
              Keine Tische verfügbar
            </div>
          }
          @for (table of tables(); track table.id) {
            <div
              class="flex items-center justify-between p-3 rounded-lg border border-gray-700 mb-2 cursor-pointer hover:bg-gray-750 hover:border-gray-600 transition-colors duration-200"
              [class.bg-orange-500]="selectedTableId() === table.id"
              [class.border-orange-500]="selectedTableId() === table.id"
              (click)="tableSelected.emit(table)">
              <div class="flex items-center gap-3">
                <span class="material-symbols-outlined text-2xl">chair</span>
                <div>
                  <div class="font-medium text-white">Tisch {{ table.number }}</div>
                </div>
              </div>
              @if (selectedTableId() === table.id) {
                <div class="text-white">
                  <span class="material-symbols-outlined text-base">check</span>
                </div>
              }
            </div>
          }
        </div>
        <div class="mt-4 pt-4 border-t border-gray-700">
          <button (click)="closed.emit()"
            class="w-full bg-gray-700 text-white py-2 px-4 rounded-lg hover:bg-gray-600">
            Abbrechen
          </button>
        </div>
      </div>
    </div>
    `,
})
export class TableSelectModalComponent {
  tables = input<Table[]>([]);
  selectedTableId = input<string | null>(null);
  tableSelected = output<Table>();
  closed = output<void>();
}
